import "./rangy-core";
import "./rangy-highlighter";
import "./rangy-classapplier";
import "./rangy-textrange";
import "./rangy-serializer";
import { debounceFn } from "@/utils/debounce";

const Plugin = {
  selectionChangeListeners: [],
  isPauseListeners: false,
  lastActiveUuid: "",
  install(app) {
    if (window.rangy.initialized) {
      app.config.globalProperties.$rangy = window.rangy;
      return;
    }
    window.rangy.init();
    app.config.globalProperties.$rangy = window.rangy;
    // app.config.globalProperties.$rangy = rangyHighlighter;
    // app.config.globalProperties.$rangy = rangyClassApplier;
    // app.config.globalProperties.$rangy = rangyTextRange;
    // app.config.globalProperties.$rangy = rangySerializer;

    this.selectionChange = debounceFn(
      () => {
        if (this.isPauseListeners) {
          return;
        }

        this.selectionChangeListeners.forEach((selectionChangeListener) => {
          selectionChangeListener();
        });
      },
      500,
      { leading: false, trailing: true },
    );

    app.config.globalProperties.$rangy.onSelectionChange = (listener) => {
      if (this.selectionChangeListeners.length === 0) {
        document.addEventListener("selectionchange", this.selectionChange);
      }
      this.selectionChangeListeners.push(listener);
    };
    app.config.globalProperties.$rangy.offSelectionChange = (listener) => {
      const listenerIndex = this.selectionChangeListeners.indexOf(listener);
      if (listenerIndex > -1) {
        this.selectionChangeListeners.splice(listenerIndex, 1);
      }
      if (this.selectionChangeListeners.length === 0) {
        document.removeEventListener("selectionchange", this.selectionChange);
      }
    };
    app.config.globalProperties.$rangy.pauseSelectionChangeListeners = (uuid) => {
      this.isPauseListeners = true;
      this.lastActiveUuid = uuid;
    };
    app.config.globalProperties.$rangy.resumeSelectionChangeListeners = (uuid) => {
      if (this.lastActiveUuid === uuid) {
        this.isPauseListeners = false;
      }
    };
  },
};
export default Plugin;
